import { Component } from '@angular/core';

@Component({
  selector: 'tun-play-icon',
  templateUrl: './play-icon.component.html'
})
export class PlayIconComponent {
}
